module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.47b1448a.jpeg";